<template>
  <div>
    <user-detail-title
        first-bread="用户管理"
        second-bread="用户管理修改"
        first-url="/user/manage"
        title-name="用户管理修改"
    />
    <user-detail-base>
      <el-form label-position="left" label-width="100px">
        <el-form-item label="用户名">
          <el-input v-model="Clist.userName" ></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="Clist.password" ></el-input>
        </el-form-item>
        <el-button @click="handleUpdate">修改</el-button>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "@/views/User/Common/UserDetailTitle";
  import UserDetailBase from "@/views/User/Common/UserDetailBase";
  export default {
    name: "ManageChange",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        Clist: {
          'id': this.$route.params.id,
          'userName':null,
          'password':null,
        },//表示Update添加的数据
      }
    },
    methods:{
      handleUpdate(){
        this.$axios.post('/api/user/updateUser',this.Clist).then(res=>{
          if(res.data.success == true){
            this.Clist= {
              'id': this.$route.params.id,
              'userName':null,
              'password':null,
            }//表示Change添加的数据,
            this.$message({
              message:'修改成功',
              type:'success'
            })
          }
        })
      }
    },
  }
</script>

<style scoped>

</style>